import React from 'react';
import { AnimatedBackdrop } from './AnimatedBackdrop';
interface PageHeaderProps {
  label: string;
  title: string;
  description?: string;
}
export function PageHeader({
  label,
  title,
  description
}: PageHeaderProps) {
  return <section className="relative w-full overflow-hidden bg-navy" data-id="element-392" data-mp="3rdarr4s2ngtf">
      <AnimatedBackdrop data-id="element-393" data-mp="3meznd9kjpyil" />
      <div className="relative mx-auto max-w-shell px-6 py-16 sm:px-8 lg:py-20" data-id="element-394" data-mp="3mgu5kg4fnciz">
        <div className="flex items-center gap-3" data-id="element-395" data-mp="2yp5bovbyqfzx">
          <span className="h-px w-8 bg-metal" aria-hidden="true" data-id="element-396" data-mp="2ynu22evu6e0w" />
          <span className="text-[11px] font-semibold uppercase tracking-label text-metal-light" data-id="element-397" data-mp="2ts6do1p6howg">
            {label}
          </span>
        </div>
        <h1 className="mt-6 max-w-3xl font-serif text-[34px] font-semibold leading-[1.1] tracking-[-0.02em] text-white sm:text-[42px] lg:text-[52px]" data-id="element-398" data-mp="33p1fouknu7fh">
          {title}
        </h1>
        {description && <p className="mt-6 max-w-2xl text-[17px] leading-[1.65] text-white/65 lg:text-lg" data-id="element-399" data-mp="2b0lyc1e23d0z">
            {description}
          </p>}
      </div>
    </section>;
}